<template>
    <div>
        <v-row align="start" justify="start">
            <v-col :class="$vuetify.breakpoint.mdAndUp ? 'ml-0': 'px-0'">
                <buttons-group
                    :items="items"
                    :indexStep="index"
                    :disabledAll="disabled"
                    @click="getIndex"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      items: ['Certificações e Selos', 'Iniciativas Institucionais', 'Premiações de Mercado'],
      disabled: true
    }
  },
  methods: {
    getIndex (index) {
      this.$emit('changeButton', index)
    },
    changeDisabled () {
      this.disabled = true
    }
  }
}
</script>

<style scoped>

</style>
